import ValidatePassword from "../validatePassword";

let registration = {
    form() {
        return {
            new_password: null,
            new_password_confirm: null,
            validatePassword: new ValidatePassword(),
            init() {
                this.$watch('new_password', (value) => {
                    this.validatePassword.setPassword(value);
                });
            },
        }
    }
}

export default registration;
